import { Pencil } from 'lucide-react';
import React from 'react';
import { IconButton, FormDrawer } from '../../ui';
import FormServiceUpdate from '../Forms/FormServiceUpdate';

export default function UpdateService(props: { handleFunction: any, service: any }) {
    const [open, setOpen] = React.useState(false);

    return (
        <div>
            <IconButton size={32} color="warning" tooltip="Modifier ce service" onClick={() => setOpen(true)}>
                <Pencil size={16} />
            </IconButton>
            <FormDrawer
                open={open}
                onClose={() => setOpen(false)}
                title="Modification du service"
                hint="Les informations existantes sont pré-remplies. Modifiez les champs souhaités puis enregistrez."
            >
                <FormServiceUpdate handleFunction={() => { setOpen(false); props.handleFunction() }} service={props.service} />
            </FormDrawer>
        </div>
    );
}
